import {AddressModel} from "@service/models/address.model";

export class ResidenceModel {
    applicationId: number;
    residenceId: number;
    status: string;  // Own, Renting
    position: string;
    cost: number;  // Rent, Mortgage
    costString: string;
    schedule: string;   // Annually, Monthly
    length: number;  // Length of Residence
    years: number;
    months: number;
    currentResidence: Boolean;
    address: AddressModel;

    constructor() {
        this.schedule = 'MONTHLY';
    }
}
